import { combineReducers } from 'redux';
import {
  EMPLOYEE_PIN_SET_SUBMITTING,
  EMPLOYEE_PIN_SET_ALLOWED_FIELDS,
  EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES,
} from 'actions/employees/pin/constants';

import createReducer from 'utils/createReducer';

const allowedFields = createReducer([], {
  [EMPLOYEE_PIN_SET_ALLOWED_FIELDS]: (draft, { payload }) => [
    ...payload.allowedFields,
  ],
});

const saveAppPermissionModal = createReducer(
  {
    message: '',
  },
  {
    [EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL]: (draft, { payload }) => ({
      ...payload,
    }),
  }
);

const showSaveAppPermissionModal = createReducer(false, {
  [EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL]: () => true,
  [EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL]: () => false,
});

const submitting = createReducer(null, {
  [EMPLOYEE_PIN_SET_SUBMITTING]: (draft, { payload }) => payload.submitting,
});

const outletsEmployees = createReducer([], {
  [EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES]: (draft, { payload }) => [
    ...payload.outletsEmployees,
  ],
});

export default combineReducers({
  allowedFields,
  saveAppPermissionModal,
  showSaveAppPermissionModal,
  submitting,
  outletsEmployees,
});
